
























import { Component, Vue } from 'vue-property-decorator'
import ApiGtag, { Category } from '@/services/api-gtag'

@Component
export default class WorkModule extends Vue {
  created() {
    ApiGtag.sendEvent(Category.Course, 'View unit', `${this.$route.params.productId}/${this.$route.params.workModuleCode}`)
  }
}
